import React from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import Icon from 'components/icon/icon.component';
import { InventoryDeliveryStatus } from 'interfaces/report.interface';
import './status-chip.style.scss';

const ICONS: Record<InventoryDeliveryStatus, 'CircleCheck' | 'Send' | 'Clock' | 'CircleAlert'> = {
  ACCEPTED: 'CircleCheck',
  IN_FLIGHT: 'Send',
  PENDING: 'Clock',
  FAILED: 'CircleAlert',
};

interface IProps {
  status: InventoryDeliveryStatus;
  /** Error text shown on hover, so failures do not need their own wide columns. */
  title?: string | null;
}

const StatusChip: React.FC<IProps> = ({ status, title }) => {
  const { t } = useTranslation();

  return (
    <span
      className={clsx('statusChip', `statusChip--${status.toLowerCase()}`)}
      title={title ?? undefined}
    >
      <Icon name={ICONS[status]} size={14} />
      {t(`report.inventory.status.${status}`)}
    </span>
  );
};

export default StatusChip;
